import { faCaretDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import { LocationDescriptor } from "history";
import React from "react";

import { CategoryKey } from "@/mk2/apps/bazaar/components/CategoryFacetOption";
import { Link } from "@/mk2/components/Link";
import useEventCallback from "@/mk2/hooks/useEventCallback";
import { getLabel } from "@/mk/bazaar/product/categories";

import styles from "./CategoryFacetSubOption.mscss";

export interface OwnProps {
    className?: string;
    category: CategoryKey;
    to?: LocationDescriptor;
    selected?: boolean;
    count?: number;
    hasSubcategories?: boolean;
    dimmed?: boolean;
    opened?: boolean;

    onSelect?(category: CategoryKey);
}

type Props = OwnProps;

const CategoryFacetSubOption = ({
    className,
    category,
    to,
    selected = false,
    dimmed = false,
    opened = false,
    count = null,
    onSelect,
    hasSubcategories = false,
}) => {
    const onSelectCallback = useEventCallback(
        (event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>) => {
            event.preventDefault();

            if (onSelect && count !== 0) {
                // Disable if count === 0
                onSelect(category);
            }
        },
        [onSelect, category],
    );

    const content = (
        <>
            {dimmed && <div className={styles.CategoryFacetSubOption__dimmed} />}
            <span>
                <span
                    className={cx(
                        styles.CategoryFacetSubOption__label,
                        selected && styles["CategoryFacetSubOption__label--selected"],
                        count === 0 && styles["CategoryFacetSubOption__label--zero"],
                    )}
                >
                    {getLabel(category)}
                </span>
                {count > 0 && <span className={styles.CategoryFacetSubOption__count}>{count}</span>}
            </span>
            {hasSubcategories && (
                <div className={styles.CategoryFacetSubOption__caret}>
                    <FontAwesomeIcon icon={faCaretDown} />
                </div>
            )}{" "}
        </>
    );

    return (
        <div
            className={cx(
                styles.CategoryFacetSubOption,
                className,
                opened && styles["CategoryFacetOption--opened"],
                count !== 0 && styles["CategoryFacetSubOption--clickable"],
            )}
        >
            {to && count !== 0 ? (
                <Link
                    to={to}
                    className={styles.CategoryFacetSubOption__container}
                    onClick={onSelectCallback}
                >
                    {content}
                </Link>
            ) : (
                <div
                    className={styles.CategoryFacetSubOption__container}
                    onClick={onSelectCallback}
                >
                    {content}
                </div>
            )}
        </div>
    );
};

CategoryFacetSubOption.displayName = "CategoryFacetSubOption";

export default React.memo<Props>(CategoryFacetSubOption);
